// extracted by mini-css-extract-plugin
export default {"title":"ProfileScreen_title__IEgyc","body":"ProfileScreen_body__KE+By"};